import React from 'react';
import { ErrorPage } from './ErrorPage';

interface State {
  hasError: boolean;
}

// Catches uncaught render errors anywhere in the app and shows a 500 page
// instead of a blank white screen (PRD Module 1.15).
export class ErrorBoundary extends React.Component<{ children: React.ReactNode }, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: unknown, info: unknown) {
    // eslint-disable-next-line no-console
    console.error('Unhandled application error:', error, info);
    const errMessage = (error as Error)?.message || '';
    const errName = (error as Error)?.name || '';
    const isChunkError =
      errName === 'ChunkLoadError' ||
      /Loading chunk|Failed to fetch dynamically imported module|Importing a module script failed/i.test(
        errMessage,
      );
    const hasReloaded = sessionStorage.getItem('webfoxx_chunk_reload') === '1';
    if (isChunkError && !hasReloaded) {
      sessionStorage.setItem('webfoxx_chunk_reload', '1');
      window.location.reload();
    }
  }

  reset = () => {
    sessionStorage.removeItem('webfoxx_chunk_reload');
    this.setState({ hasError: false });
  };

  render() {
    if (this.state.hasError) {
      return <ErrorPage code={500} onReset={this.reset} />;
    }
    return this.props.children;
  }
}
